import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

export type PostsMediaType = 'all' | 'image' | 'video';
type PostsFilterMediaType = PostsMediaType | 'none' | 'skeleton';
export type PostsFeedType = 'all' | 'Post' | 'Slide' | 'Collab' | 'Portfolio';

export interface PostsFilterData {
  media: PostsFilterMediaType;
  feedType?: PostsFeedType;
}

@Component({
  selector: 'app-posts-filter-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonRadio,
    IonRadioGroup,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar,
  ],
  templateUrl: './posts-filter-modal.component.html',
  styleUrls: ['./posts-filter-modal.component.scss'],
})
export class PostsFilterModalComponent implements OnInit {
  private readonly modalCtrl = inject(ModalController);

  @Input() filters?: PostsFilterData | null;
  /** Synthetic states belong to the generated list-pattern preview, not the Posts admin page. */
  @Input() includePreviewModes = false;
  @Input() includeFeedTypes = false;
  media: PostsFilterMediaType = 'all';
  feedType: PostsFeedType = 'all';

  ngOnInit(): void {
    this.media = this.filters?.media || 'all';
    this.feedType = this.filters?.feedType || 'all';
  }

  apply(): void {
    this.modalCtrl.dismiss({ filters: { media: this.media, feedType: this.feedType } satisfies PostsFilterData });
  }

  clear(): void {
    this.modalCtrl.dismiss({ clear: true });
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
